import { render, staticRenderFns } from "./AppartBloc.vue?vue&type=template&id=2c3afc5d&"
import script from "./AppartBloc.vue?vue&type=script&lang=ts&"
export * from "./AppartBloc.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports